<script setup lang="ts">
import { bin } from '@/components/icons/icons';
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import Button from '@/components/buttons/Button.vue';
import { computed } from 'vue';

interface PtwDeleteButtonProps {
  hidden?: boolean;
  disabled?: boolean;
  size?: 'x-small' | 'small' | 'default' | 'large' | 'x-large';
}

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<PtwDeleteButtonProps>(), {
  size: 'small',
  hidden: false,
  disabled: false,
});

const passdownProps = computed(() => ({
  hidden: props.hidden,
  disabled: props.disabled,
  size: props.size,
}));

defineEmits<{
  delete: [];
}>();
</script>

<template>
  <Tooltip>
    <template #target="{ props: tooltipProps }">
      <Button
        v-show="!props.hidden"
        v-bind="{
          ...$attrs,
          ...tooltipProps,
          ...passdownProps,
          class: [$attrs.class, tooltipProps.class].filter(Boolean),
        }"
        variant="text"
        :icon="bin"
        @click="$emit('delete')"
      />
    </template>
    <template #tooltip> {{ $t('DeleteButtonTooltip') }} </template>
  </Tooltip>
</template>
